import { p as ApiError } from "./createFetchClient-Dc_ZMuq7.js";
// src/errors/ManagementClientAuthError.ts
var ManagementClientAuthError = class extends ApiError {
	title;
	message;
	constructor(title, message, res) {
		super(res);
		this.name = "ManagementClientAuthError";
		this.title = title;
		this.message = message;
	}
};
// src/errors/ManagementSessionMintError.ts
/**
* The Manage client has no credential of its own and could not mint a session token from the
* login cookie.
*
* - Only a `management-token` client with `mintSessionToken` (control-ui) mints; a bearer client
*   never raises it.
* - The login page in place of the token: the session expired, or there is no cookie (off the
*   stack host).
*/
var ManagementSessionMintError = class extends ManagementClientAuthError {
	constructor({ title, message, response, request, data }) {
		super(title, message, {
			response,
			request,
			data
		});
		this.name = "ManagementSessionMintError";
	}
};
export { ManagementClientAuthError as n, ManagementSessionMintError as t };

//# sourceMappingURL=ManagementSessionMintError-KUX3utTV.js.map